import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.875.75v22.5m0-7.5 14.25-8.25L4.875.75"
    }, null, -1)
  ]));
}
const interfaceFavoriteFlag = { render };
export {
  interfaceFavoriteFlag as default,
  render
};
//# sourceMappingURL=interface-favorite-flag.svg.js.map
